import * as React from "react";
import * as ReactDOM from "react-dom";
import {connect} from "react-redux";
import {getScore} from "../../../../../store/reducers/score";
import SummarySection from "./summary/SummarySection";
import HintsSection from "./score/HintsSection";
import QuestionSection from "./hints/QuestionsSection";
import Button from '../../../../common/ui/button/Button';
import {startGame} from "../../../../../store/actions/game";
import {showMainMenu} from "../../../../../store/actions/screens";
import HighlightText from '../../../../common/highlight-text/HighlightText';

interface GameOverProps
{
    score: number;
    showMainMenu: () => void;
    startGame: () => void;
}

import './GameOver.scss';

class GameOver extends React.Component<GameOverProps, null>
{
    constructor(public props: GameOverProps)
    {
        super(props);
    }



    render() : JSX.Element
    {
        const {score} = this.props;

        return <span styleName={'game-over'}>

            <div styleName={'content'}>

                <div styleName={'score-and-hints'}>


                    <span styleName={'highlight'}>

                        <HighlightText type={'blue'}>time's up!</HighlightText>

                    </span>

                    <HintsSection />

                    {/*<ScoreSection />*/}
                    <QuestionSection />
                    {/*<ScoreSection />*/}

                </div>

                <SummarySection />

            </div>



            <div styleName={'floating-ui'}>

                <Button
                    type={'main-menu'}
                    onClick={this.props.showMainMenu}>main menu</Button>

                <Button
                    type={'play-again'}
                    onClick={this.props.startGame}>play again</Button>

                <Button
                    type={'more-info'}
                    onClick={null}>

                    <a href={'assets/certificate.pdf'} download="Power the UK Certificate.pdf">Certificate</a>

                </Button>




            </div>

        </span>;
    }
}



/**
 * map the state to props
 * @param state
 */
const mapStateToProps = state =>
{
    return {
        score: getScore(state),

    }
};


/**
 * map dispatch functions to the component props
 * @param dispatch
 * @returns {{onModeSelect: ((mode: string) => any); onCountrySelect: ((country: string) => any)}}
 */
const mapDispatchToProps = dispatch =>
{
    return {
        showMainMenu: () => dispatch(showMainMenu()),
        startGame: () => dispatch(startGame()),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(GameOver);



// WEBPACK FOOTER //
// ./src/ts/app/screens/game/modals/game-over/GameOver.tsx